<template>
      <div id="he-plugin-standard"></div>
</template>
  
  <script>
  
  export default {
    name: 'he-feng-weather',
    data () {
      return {
      }
    },
    mounted () {
      
    },
    created(){
        //和风天气插件调用
        window.WIDGET = {
          "CONFIG": {
            "layout": "1",
            "height": "150",
            "background": "1",
            "dataColor": "FFFFFF",
            "padding": "10px 10px 10px 10px",
            "key": "1aec97e3127843ac9d6c232b50c29196"
          }
        };
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src="https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0";
        document.getElementsByTagName('head')[0].appendChild(script);
    },
    methods: {
    }
  }
  </script>
  
  <style lang="scss">
    #he-plugin-standard{
      width: 96% !important;
      margin: 2% !important;
    }

  </style>
  


// WEBPACK FOOTER //
// HeFengWeather.vue?0645e21c